import React from 'react';
import _ from 'lodash';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import useIsMobile from '../../../hooks/useIsMobile';
const RelatedArticles = ({
  blogData = [],
  drugName = '',
  heading = '',
  isSpanishArticles = false
}) => {
  const isMobile = useIsMobile();

  const articles = blogData.map((post, id) => {
    let img =
      post?.thumbnail_images?.medium?.url || post?.thumbnailImages?.medium?.url;
    return (
      <a
        className="article"
        key={id}
        href={isSpanishArticles ? `/es/recursos/${post.url}` : post.url}
      >
        <div className="articleMainData">
          <LazyLoadImage
            className="article-img"
            src={
              img
                ? img
                : '/content/images/prescriptions/Generic_Blog_Template.jpg'
            }
            alt={isSpanishArticles ? (post.altText ? post.altText : '') : ''}
          />
          <div className="article-details">
            <span className="link themeFocus">
              {!isMobile && (
                <h3 dangerouslySetInnerHTML={{ __html: post.title }}></h3>
              )}
              {isMobile && (
                <h3>
                  <div
                    className="truncate truncateTwoLine"
                    dangerouslySetInnerHTML={{
                      __html: post.title
                    }}
                  />
                </h3>
              )}
            </span>
          </div>
        </div>
      </a>
    );
  });

  return (
    <div className="related-articles" hidden={_.isEmpty(articles)}>
      {!_.isEmpty(articles) &&
        (_.isEmpty(heading) ? (
          <h2 className="newsResearch" id="news-research-heading">
            <span>{drugName}&nbsp;</span>
            <span>News & Research</span>
          </h2>
        ) : (
          <h2 className="newsResearch" id="news-research-heading">
            <span>{heading}</span>
          </h2>
        ))}
      <div className="article-container">
        <div className="article-flexGrid">{articles}</div>
      </div>
    </div>
  );
};

export default React.memo(RelatedArticles);
